import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
  
ChartJS.register(
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend
);

const Construct_code_category = [
    { construct: "Self-Efficacy", code: "se", category: "Student Beliefs" },
    { construct: "Cognitive Engagement", code: "cog", category: "Learning Behaviors" },
    { construct: "Behavioral Engagement", code: "beh", category: "Learning Behaviors" },
    { construct: "Affective Engagement", code: "aff", category: "Learning Behaviors" },
    { construct: "Autonomy", code: "aut", category: "Classroom Context" },
    { construct: "Relatedness", code: "rel", category: "Classroom Context" },
    { construct: "Value", code: "val", category: "Student Beliefs" },
    { construct: "Self-Regulation", code: "srt", category: "Learning Behaviors" },
    { construct: "Intrinsic Motivation", code: "amot", category: "Student Beliefs" }, // or autonomous motivation? 
    { construct: "Extrinsic Motivation", code: "cmot", category: "Student Beliefs" }, // or controlled motivation?
    { construct: "Academic Burden", code: "bur", category: "Student Beliefs" },
    { construct: "Belongingness", code: "bel", category: "Classroom Context" }, // or perceived belonging?
    { construct: "Cultural Congruity", code: "cult", category: "Classroom Context" },
    { construct: "Withdrawal Intention", code: "with", category: "Learning Behaviors" },
];

const TrendChart = ({ trendData }) => {
    const ConstructMeta = {};
    Construct_code_category.forEach(({ code, construct, category }) => {
      ConstructMeta[code] = { construct, category };
    });
  
    const trendByCategory = {
      "Student Beliefs": {},
      "Learning Behaviors": {},
      "Classroom Context": {},
    };
  
    for (const [code, points] of Object.entries(trendData)) {
      const meta = ConstructMeta[code] || {};
      const category = meta.category || "Other";
      const label = meta.construct || code;
  
      if (!trendByCategory[category]) trendByCategory[category] = {};
  
      trendByCategory[category][label] = points.map((p) => ({
        x: new Date(p.x),
        y: Number(p.y),
      }));
    }
  
    return (
      <div className="trend-container">
        {Object.entries(trendByCategory).map(([category, constructs]) => {
          const datasets = Object.entries(constructs).map(([label, points], i) => ({
            label,
            data: points,
            fill: false,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 3,
            borderColor: `hsl(${(i * 60) % 360}, 70%, 50%)`,
            spanGaps: true,
          }));
  
          const chartData = { datasets };
  
          return (
            <div key={category} style={{ marginBottom: "3rem" }}>
              <h3>{category}</h3>
              <Line
                data={chartData}
                options={{
                  responsive: true,
                  scales: {
                    x: {
                      type: "time",
                      time: {
                        unit: "day",
                        tooltipFormat: "MMM d",
                      },
                      title: {
                        display: true,
                        text: "Date",
                      },
                    },
                    y: {
                      min: 1,
                      max: 6,
                      title: {
                        display: true,
                        text: "Average Score",
                      },
                      ticks: {
                        stepSize: 1,
                        callback: (value) =>
                          ({
                            1: "Strongly Disagree",
                            2: "Disagree",
                            3: "Slightly Disagree",
                            4: "Slightly Agree",
                            5: "Agree",
                            6: "Strongly Agree",
                          }[value] || value),
                      },
                    },
                  },
                  plugins: {
                    legend: { position: "right" },
                  },
                }}
              />
            </div>
          );
        })}
      </div>
    );
  };
  

// const TrendChart = ({ trendData }) => {
//     console.log("TrendChart - trendData:", trendData);

//     const allDates = Object.values(trendData)
//         .flat()
//         .map(d => new Date(d.x).getTime());

//     const minX = new Date(Math.min(...allDates)).toISOString();
//     const maxX = new Date(Math.max(...allDates)).toISOString();

//     // const datasets = Object.entries(trendData).map(([construct, points], i) => ({
//     //     label: construct,
//     //     data: points,
//     //     fill: false,
//     //     tension: 0.3,
//     //     borderWidth: 2,
//     //     pointRadius: 3,
//     //     borderColor: `hsl(${(i * 30) % 360}, 70%, 50%)`,
//     //     spanGaps: true,
//     // }));

//     const datasets = Object.entries(trendData).map(([construct, points], i) => ({
//         label: construct,
//         data: points.map(p => ({ x: new Date(p.x), y: Number(p.y) })),
//         fill: false,
//         tension: 0.3,
//         borderWidth: 2,
//         pointRadius: 3,
//         spanGaps: true,
//     }));

//     const allLabels = [
//         ...new Set(
//           datasets
//             .flatMap(ds => ds.data.map(p => p.x))
//             .sort((a, b) => new Date(a) - new Date(b))
//         ),
//     ];
      

//     const chartData = {
//         labels: allLabels,
//         datasets,
//     };
//     console.log("TrendChart - chartData:", chartData);

//     const options = {
//         responsive: true,
//         // parsing: false,
//         scales: {
//             x: {
//                 type: "time",
//                 time: {
//                     unit: "day",
//                     tooltipFormat: "MMM d",
//                 },
//                 title: {
//                     display: true,
//                     text: "Date",
//                 },
//             },
//             y: {
//                 min: 1,
//                 max: 6,
//                 title: {
//                     display: true,
//                     text: "Average Score",
//                 },
//                 ticks: {
//                     stepSize: 1,
//                     callback: (value) => ({
//                         1: 'Strongly Disagree 1',
//                         2: 'Disagree 2',
//                         3: 'Slightly Disagree 3',
//                         4: 'Slightly Agree 4',
//                         5: 'Agree 5',
//                         6: 'Strongly Agree 6',
//                     }[value] || value),
//                 },
//             },
//         },
//         plugins: {
//             legend: {
//                 position: "right",
//             },
//         },
//     };

//     datasets.forEach(ds => {
//         console.log(`Dataset: ${ds.label}`, ds.data);
//         ds.data.forEach(p => {
//           if (typeof p.y !== "number") {
//             console.error(`Invalid y type in ${ds.label}:`, p);
//           }
//           if (typeof p.x !== "string" && !(p.x instanceof Date)) {
//             console.error(`Invalid x type in ${ds.label}:`, p);
//           }
//         });
//     });

//     return <Line data={chartData} options={options} />;
// };

export default TrendChart;